import React from 'react';
import { Menu } from '@blueprintjs/core';
export function Sidebar(_a) {
    var children = _a.children, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b;
    var _c = React.useState("patterns-sidebar"), className = _c[0], setClassName = _c[1];
    React.useEffect(function () {
        if (collapsed) {
            setClassName('patterns-sidebar patterns-sidebar-collapsed');
        }
        else {
            setClassName('patterns-sidebar');
        }
    }, [collapsed]);
    return React.createElement("div", { className: className },
        React.createElement(Menu, null, children));
}
//# sourceMappingURL=sidebar.js.map